import React from "react"

import {
    Box,
    Button,
    Chip, Tooltip,
    Typography,
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import BlockIcon from "@mui/icons-material/Block"
import PersonIcon from "@mui/icons-material/Person"

import {
    t,
    Trans,
} from "@lingui/macro"
import { Link } from "react-router-dom"

import { ColoredProgressBar } from "components/commons"

import { getChipProps } from "components/commons/task-chip-props"
import {GridRenderCellParams} from "@mui/x-data-grid/models/params/gridCellParams";
import {renderProgress} from "../../../filledProgressBar/filledProgressBar";


const defaultColumnDefinition: any = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
}
const getTaskTableColumns = (): any => {
    return [

        {
            ...defaultColumnDefinition,
            field: "title",
            headerName: t({
                id: "ttc-title",
                message: "Titolo Task",
            }),
            flex: 1,
            sortable: false
        },
        {
            ...defaultColumnDefinition,
            field: "status",
            headerName: t({
                id: "ttc-status",
                message: "Stato"
            }),
            flex: 2,
            renderCell: (params: any) => {
                return <Chip {...getChipProps(params.row.status)} />
            },
            sortable: false
        },
        {
            ...defaultColumnDefinition,
            field: "cost",
            headerName: t({
                id: "ttc-cost",
                message: "Costo",
            }),
            flex: 1,
            sortable: false
        },
        {
            ...defaultColumnDefinition,
            field: "paymentStatus",
            headerName: t({
                id: "ttc-payment-status",
                message: "Stato pagamento"
            }),
            flex: 2,
            sortable: false,
            renderCell: (params: { row: any }) => (
                <Box width={"100%"}>
                    {params.row.paymentStatus==="DA PAGARE" && <Typography color={'error'}>
                        {params.row.paymentStatus}
                    </Typography>}
                    {params.row.paymentStatus==="PAGATA" && <Typography color={'success.main'}>
                        {params.row.paymentStatus}
                    </Typography>}
                    {params.row.paymentStatus!=="PAGATA" && params.row.paymentStatus!=="DA PAGARE"  && <Typography >
                        {params.row.paymentStatus}
                    </Typography>}
                </Box>
            ),
        },
        {
            ...defaultColumnDefinition,
            field: "progress",
            headerName: t({
                id: "ttc-progress",
                message: "Progresso"
            }),
            flex: 2,
            sortable: false,
            renderCell: (params: { row: any }) => {
                return (
                    renderProgress(params.row.progress)
                )
            }
        },
        {
            ...defaultColumnDefinition,
            field: "action",
            headerName: t({
                id: "ttc-action",
                message: "Azioni"
            }),
            flex: 1,
            sortable: false,
            renderCell: (params: { row: any }) => (
                <Box>
                    <Tooltip title={t({
                        id: "ttc-action-contests",
                        message: "Contesta"
                    })}>
                        <BlockIcon></BlockIcon>
                    </Tooltip>
                    <Tooltip title={t({
                        id: "ttc-action-reassign",
                        message: "Riassegna"
                    })}>
                        <PersonIcon></PersonIcon>
                    </Tooltip>
                    <Tooltip title={t({
                        id: "ttc-action-delete",
                        message: "Elimina"
                    })}>
                        <DeleteIcon></DeleteIcon>
                    </Tooltip>

                </Box>

            ),
        },
        {
            ...defaultColumnDefinition,
            field: "button",
            flex: 2,
            sortable: false,
            renderCell: (params: { row: any }) => (
                // <Link key={`task-${params.row.id}`} to={`/microjob`}>
                    <Button
                        variant="contained"
                        disableElevation
                        disabled={params.row.status==="da assegnare"}
                        size="small"
                        sx={{
                            textTransform: 'none',
                            backgroundColor: 'secondary.main',
                            color: 'white',
                        }}
                        onClick={()=>(console.log(params))}>
                        <Typography>
                            <Trans id="task-table.payment">
                                Gestisci pagamento
                            </Trans>
                        </Typography>
                    </Button>
                // </Link>

            ),
        },
    ]
}

export default getTaskTableColumns
